import {Link} from 'react-router-dom';
import React,{ useState,useEffect } from 'react';
import { Loader} from 'react-feather';
function Categories(){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [categories,setCategories]=useState([]);
    const [totalResult,setTotalResults]=useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        fetchData(baseUrl+'/categories');
    },[]);

    function fetchData(baseurl){
        setLoading(true);
        fetch(baseurl)
        .then((response) => response.json())
        .then((data) => {
            setLoading(false);
            setCategories(data.results);
            setTotalResults(data.count);
        });
    }

    function changeUrl(baseurl){
        fetchData(baseurl);
    }

    var links=[];
    var limit=12;
    var totalLinks=totalResult/limit;
    for(let i=1; i<=totalLinks; i++){
        links.push(<li className="page-item"><Link onClick={()=>changeUrl(baseUrl+`/categories/?page=${i}`)} to={`/categories/?page=${i}`} className="page-link">{i}</Link></li>)
    }

    return (
        <section className="container mtopcon normal-mt-sctn">
                <div className="col-12 p-2"> 
                    { loading === true ? <p className='text-center'>Loading <Loader/></p> : <>
                        <h3 className="mb-5 text-center font-bold">                        
                         Built for businesses{" "}
                                <span className="bg-gold-yellow">with repeat customers</span></h3>    
                        <div className='row'>
                            {
                                categories.map((category)=>{
                                    return (
                                            <div className='col-6 col-lg-3 mb-3'>
                                                <Link to={`/`} className='text-dark'>
                                                    <div className='cat-imgcon'><img src={category.cat_img} alt="..."/></div>
                                                </Link> 
                                            </div>
                                        
                                    )
                                    
                                })
                            }                             
                        </div> 
                        <div className="background0 mt-6 pt-6indx0 br40">
                            <div className="content0">
                                <h1 className='mt-4'>Your next repeat customer<br/> is just one NUDGE away.</h1>
                                <div  className="row">
                                    <div  className="col-12 col-md-12 text-center mb-4 mt-3">                                            
                                        <Link className="main-btn btn-hover text-white bg-blue" to="/seller/register">Create account for free</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}                       
                </div>

        </section>
    )
}

export default Categories;